var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import * as React from "react";
import styled from "styled-components";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Typography from "@material-ui/core/Typography";
import "likert-react/dist/main.css";
import PeerReviewForm from "./PeerReviewForm";
import PeerReviewsGuidance from "./PeerReviewsGuidance";
import * as peerReviewsActions from "../../state/peerReviews/actions";
import Togglable from "../../utils/Togglable";
import { useTypedSelector } from "../../state/store";
var BoldTypography = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: bold;\n  margin-bottom: 15px;\n"], ["\n  font-weight: bold;\n  margin-bottom: 15px;\n"])));
var TopMarginDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 15px;\n"], ["\n  margin-top: 15px;\n"])));

var PeerReviews = function PeerReviews() {
  var dispatch = useDispatch();
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });

  if (!quiz) {
    return React.createElement("div", null);
  }

  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var peerReviewQuestions = quiz.peerReviewCollections;
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });

  if (!languageInfo) {
    return React.createElement("div", null);
  }

  if (quizDisabled) {
    return React.createElement(Typography, {
      variant: "subtitle1"
    }, languageInfo.peerReviews.peerReviewsInfoForLoggedOutUser);
  }

  var peerReviewsLabels = languageInfo.peerReviews;
  var giveExtraPeerReviewsLabel = quizAnswer.status === "confirmed" ? peerReviewsLabels.giveExtraPeerReviewsQuizConfirmed : peerReviewsLabels.giveExtraPeerReviews;
  useEffect(function () {
    dispatch(peerReviewsActions.fetchPeerReviewAlternatives());
  }, []);

  var morePeerReviewsRequired = function morePeerReviewsRequired() {
    return (userQuizState ? userQuizState.peerReviewsGiven : 0) < quiz.course.minPeerReviewsGiven;
  };

  if (peerReviewQuestions.length === 0) {
    return React.createElement(Typography, {
      variant: "subtitle1"
    }, peerReviewsLabels.quizInvolvesNoPeerReviewsInstruction);
  }

  return React.createElement("div", null, morePeerReviewsRequired() ? React.createElement(React.Fragment, null, React.createElement(PeerReviewsGuidance, {
    guidanceText: peerReviewQuestions[0].texts[0].body,
    givenLabel: peerReviewsLabels.givenPeerReviewsLabel,
    peerReviewsCompletedInfo: peerReviewsLabels.peerReviewsCompletedInfo
  }), React.createElement(PeerReviewForm, {
    languageInfo: peerReviewsLabels
  })) : React.createElement(React.Fragment, null, React.createElement(BoldTypography, {
    variant: "subtitle1"
  }, giveExtraPeerReviewsLabel), React.createElement(Togglable, {
    initiallyVisible: morePeerReviewsRequired(),
    hideButtonText: peerReviewsLabels.hidePeerReviewLabel,
    displayButtonText: peerReviewsLabels.displayPeerReview
  }, React.createElement(TopMarginDiv, null, React.createElement(PeerReviewsGuidance, {
    guidanceText: peerReviewQuestions[0].texts[0].body,
    givenLabel: peerReviewsLabels.givenPeerReviewsLabel,
    peerReviewsCompletedInfo: peerReviewsLabels.peerReviewsCompletedInfo
  }), React.createElement(PeerReviewForm, {
    languageInfo: peerReviewsLabels
  })))));
};

export default PeerReviews;
var templateObject_1, templateObject_2;